module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('a', {
    staticClass: "app-share",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('img', {
    attrs: {
      "src": "static/wx_tip.png"
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b134937c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/AppShare.vue
// module id = 341
// module chunks = 0